import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { roundPrice } from 'lib/pricing_utils';
import './index.scss';

class CheckoutSummaryPricingRemainder extends React.Component {
  static displayName = 'CheckoutSummaryPricingRemainder';

  _shouldRenderRemainderInLocal = () => {
    return (
      this.props.remainder_formatted !==
      this.props.remainder_in_local_currency_formatted
    );
  };

  _renderCreditNotes = () => {
    const { intl, remainder_charge_days_offset, remainder_payment_date, remainder_formatted } = this.props;
    const dayCount = remainder_charge_days_offset;
    const chargeDate = new Date(remainder_payment_date);

    return (
      <div className="CheckoutSummary-CreditNotes">
        <p>
          <FormattedMessage
            id="THE_REMAINING_BALANCE_WILL_BE_CHARGED"
            defaultMessage="The remaining balance of <strong>{price}</strong> will be charged automatically {dayCount} {dayCount, plural, one {day} other {days}} before the experience on {date}."
            values={{
              price: roundPrice(remainder_formatted),
              dayCount,
              date: intl.formatDate(chargeDate, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              }),
              strong: (chunks) => <strong>{chunks}</strong>,
            }}
          />
        </p>
      </div>
    );
  };

  _remainderInLocalCurrencyText = () => {
    return (
      <span>
        {' '}
        <FormattedMessage
          id="PLEASE_PAY_IN_THE_LOCAL_CURRENCY_THE_AMOUNT_OF"
          defaultMessage="Please pay in the local currency amount of"
        />{' '}
        <strong>
          {roundPrice(this.props.remainder_in_local_currency_formatted)}
        </strong>
        .
      </span>
    );
  };

  _renderCashNotes = () => {
    const { intl, date, remainder_formatted } = this.props;
    const arrivalDate = new Date(date);
    return (
      <div className="CheckoutSummary-CashNotes">
        <p>
          <FormattedMessage
            id="REMAINING_BALANCE_DUE_ON_ARRIVAL"
            defaultMessage="The remaining balance of <strong>{price}</strong> should be paid when you arrive on {date}."
            values={{
              price: roundPrice(remainder_formatted),
              date: intl.formatDate(arrivalDate, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              }),
              strong: (chunks) => <strong>{chunks}</strong>,
            }}
          />
          {this._shouldRenderRemainderInLocal()
            ? this._remainderInLocalCurrencyText()
            : null}
        </p>
      </div>
    );
  };

  render() {
    return (
      <div className="CheckoutSummary-ContentBox RemainderNotes">
        {this.props.remainder_in_cash
          ? this._renderCashNotes()
          : this._renderCreditNotes()}
      </div>
    );
  }
}

export default injectIntl(CheckoutSummaryPricingRemainder);
